<template>
    <div v-if="integrationId && items">
        <div v-if="items">
            <v-data-table
                sortBy="id"
                :sortDesc="true"
                :items="items"
                :footer-props="{'items-per-page-options': [10, 25, 50, 100]}"
                :headers="headers"
                :options="{ itemsPerPage: -1, sortDesc: ['id'] }">
                <!-- action to view records -->
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="pt-1 pb-1">
                        <v-btn x-small @click="onEdit(item)">Edit</v-btn>
                        <v-btn x-small class="white--text" color="#FF7033" @click="onDelete(item)">Delete</v-btn>
                    </div>
                </template>
            </v-data-table>
        </div>
        <p v-else-if="items.length <= 0">No company & location mapping yet.</p>
        <v-progress-linear
            v-else
            indeterminate
            color="primary"
            class="mb-5">
        </v-progress-linear>
        <Modal
            ref="modal"
            color="error"
            okText="delete" />
    </div>
</template>

<script>
import Modal from '@/js/components/Modal'
import { EventBus } from '@/js/event-bus.js'
export default {
    props: {
        integrationId: { type: Number, default: null },
        machship_field: { type: String, default: 'companyId' }
    },
    components: {
        Modal
    },
    data() {
        return {
            headers: [
                // { text: 'id', value: 'id' },
                { text: 'From Label', value: 'from_label' },
                { text: 'From Value', value: 'from_value' },
                { text: 'To Label', value: 'to_label' },
                { text: 'To Value', value: 'to_value' },
                { text: 'Actions', value: 'actions', width: '150px'},
            ],
            items: null,
        }
    },
    watch: {
        integration(value, old_value) {
            if (value != old_value) {
                this.fetchMappingcompanyLocations()
            }
        }
    },
    mounted() {
        this.items = []
        this.fetchMappingcompanyLocations()
    },
    methods: {
        // this will fetch all company and location mapping items
        fetchMappingcompanyLocations() {

            if (!this.integrationId) {
                return
            }
            this.$http
                .get('/api/valuelookups/company-location/' + this.integrationId + '?machship_field=' + this.machship_field)
                .then(({ data }) => {
                    if (data.status) {
                        this.items = []
                        for (let [key, value] of Object.entries(data.result)) {
                            this.items.push(value)
                        }
                        this.$emit('mapped', this.items)
                    } else {
                        EventBus.$emit('show-error', 'Theres an error while fetching company and location mapping. Please try again later')
                    }
                })
                .catch( err => EventBus.$emit('show-error', err))
        },

        onDelete(map) {

            this.$refs.modal.onShow(
                'Delete Confirmation',
                'Are you sure you want to delete this mapping?',
                () => { return this.onDeleteConfirm(map) }
            )
        },

        onDeleteConfirm(map) {
            let index = this.findMapIndex(map)

            if (index >= 0) {
                this.items.splice(index, 1)
                return this.$http
                    .delete('/api/valuelookups/' + map.id)
                    .then(({ data }) => {
                        EventBus.$emit('show-success', "Successfully deleted mapping!");
                    })
                    .catch( err => EventBus.$emit('show-error', err))
            }
        },

        onEdit(map) {
            this.$emit('onEdit', map)
        },

        findMapIndex(map) {
            // remove current item selected
            let index = this.items.findIndex(item => {
                return item.id == map.id
            })

            return index
        }

    }
}
</script>
